<template>
  <section ref="horizontalWrapper"
           @touchstart="handleTouchStart"
           @touchend="handleTouchEnd"
           @touchmove="handleTouchMove"
           :class="[
               'history-screen-container',
               'horizontal-wrapper',
               {
                'is-active-first-slide': isFirstSlide
              }
           ]">
    <div class="horizontal-track"
         v-animateonscroll="{ enterClass: 'fade-in'}"
         @animationend="showAnimation">
      <div
          :class="[
             'navigation-info-container',
         ]"
      >
        <div class="navigation-info-content main-container">
          <div :class="['arrow-container', 'left-direction', {'is-active' : !isFirstSlide }]"
               @touchstart.stop
               @touchend.stop
               @touchmove.stop
               @click.stop="changeId(currentSlide - 1)">
            <img :src="getUrlIcons('arrow-purple')" alt="arrow">
          </div>
          <div class="left-container">
            <transition name="fade-opacity-lazy" mode="out-in">
            <div class="text-info-container" v-if="!activeItem?.leftInfo?.img && activeItem.leftInfo.title">
              <div class="top-container">
                <medium-title
                    :class="['animation-opacity', {'is-active-opacity' : isVisible(0)}]"
                    :font-family="$isMobile
              ? 'EurostileR'
              : 'Eurostile'">
                  {{ activeItem.leftInfo.title }}
                </medium-title>
                <main-title class="color-title-container"
                            :class="['animation-opacity', {'is-active-opacity' : isVisible(1)}]"
                            :font-family="'Verdana'"
                            v-if="activeItem?.colorTitle">
               <span v-for="(itemColor, index) in activeItem.colorTitle.title"
                     :class="[{'orange-title bold-title' : activeItem.colorTitle?.titleBoldOrange?.includes(itemColor),
                      'active-symbol': itemColor === '.' || itemColor === ',',
                      'active-symbol-word': itemColor === '-',
                     'bold-title' : activeItem.colorTitle?.titleBold?.includes(itemColor)}]"
                     :key="index">
                {{ itemColor }}
              </span>
                </main-title>
              </div>
              <div class="bottom-container" v-if="activeItem?.leftInfo?.actions">
                <card-with-line v-for="(item, index) in activeItem.leftInfo.actions"
                                :class="['animation-opacity', {'is-active-opacity' : isVisible(index + 2)}]"
                                class="is-active-history"
                                :font-family="'Verdana'"
                                :key="index"
                                :item="item"/>
              </div>
            </div>
              <div class="img-container" v-else-if="activeImg && !activeItem.leftInfo.title" :key="activeImg">
                  <img :src="getUrl(`history/${activeImg}`)"
                       alt="bg">
              </div>
            </transition>
          </div>
          <div class="right-container-history"
               :style="{ '--custom-height': activeHeight }"
               :class="['animation-opacity', {'is-active-opacity' : isVisible(3)},
               {'is-active-first-slide' : isFirstSlide}]">
            <div class="right-content-history">
              <div :class="['big-title-container', 'medium-title', `${activeItem.id === 0 ? 'orange': 'purple'}-title`]">
                <Vue3Odometer :value="activeItem.rightInfo.yearTitle" />
              </div>
              <transition name="fade-opacity-lazy" mode="out-in" @after-leave="checkHeight">
                <div class="main-title-container orange-title" :key="activeItem?.rightInfo.mainTitle" v-if="activeItem?.rightInfo?.mainTitle">
                  {{ activeItem?.rightInfo.mainTitle }}
                </div>
                <div class="medium-title-container orange-title Verdana-title"
                     :key="activeItem?.rightInfo.title"
                     v-else>
                  {{ activeItem?.rightInfo.title }}
                </div>
              </transition>
              <transition name="fade-opacity-lazy"  mode="out-in" @after-leave="checkHeight">
                <div class="small-title-container dark-purple-title Verdana-title"
                     :key="activeItem?.rightInfo.text"
                     v-if="activeItem?.rightInfo?.text">
                  {{ activeItem.rightInfo.text }}
                </div>
              </transition>
            </div>
          </div>
            <div
                :class="['arrow-container', {'is-active' : !isLastSlide && isVisible(3), 'is-first-slide': isFirstSlide }]"
                  @touchstart.stop
                  @touchend.stop
                  @touchmove.stop
                 @click.stop="changeId(currentSlide + 1)">
              <img :src="getUrlIcons(isFirstSlide ? 'arrow' : 'arrow-purple')" alt="arrow">
            </div>
        </div>
      </div>
    </div>

    <transition name="fade-opacity-lazy">
      <block-slider
          :is-active-static-last-slide="$isMobile"
          v-if="currentSlideForNavigation !== -1"
          :is-active-focus="false"
          class="center-info-container"
          :is-active-out="true"
          :class-name="'card-slider-history-container'"
          :id-out="currentSlideForNavigation"
          :info-cards="navigationArr"/>
    </transition>

    <transition name="fade-opacity-lazy">
      <div :key="isLastSlide" :class="['bg-container', {'last-item': isLastSlide, 'is-not-last': !isLastSlide}]">
        <img class="last-item" v-if="isLastSlide" :src="getUrl(bgImgTwo)" alt="bg">
        <img v-else :src="getUrl(bgImg)" alt="bg">
      </div>
    </transition>

  </section>
</template>

<script>

import ScrollMixin from "@/mixins/scroll.mixin";
import BlockSlider from "@/components/entities/blocks/BlockSlider.vue";
import {mapActions} from "vuex";
import MainTitle from "@/components/shared/text/MainTitle.vue";
import MediumTitle from "@/components/shared/text/MediumTitle.vue";
import LineBlock from "@/components/shared/LineBlock.vue";
import CardWithLine from "@/components/entities/cards/CardWithLine.vue";
import Vue3Odometer from 'vue3-odometer'

export default {
  name: "HistoryScreenNew",
  components: {CardWithLine, LineBlock, MediumTitle, MainTitle, BlockSlider, Vue3Odometer},
  mixins: [ScrollMixin],
  data() {
    return {
      activeHeight: 0,
      lengthAnimation: 6,
      visibleIndexItem: -1,
      bgImg: 'history-bg.webp',
      bgImgTwo: 'history/bg-2025.webp',
      arrSlider: [
        {
          id: 0,
          idSlide: -1,
          leftInfo: {
            title: 'О компании',
            boldText: 'AVEA BASIS',
            boldOrangeText: 'более 12 лет на рынке',
            text: 'ООО «АВЕА-Технолоджи» более 12 лет на рынке, многопрофильное производственное предприятие в Москве, разрабатывает и производит станочную и инструментальную оснастку под брендом AVEA BASIS, оказывает услуги по контрактному производству. ',
            actions: [
              {
                title: 'Технологический партнер'
              },
              {
                title: 'Интегратор автоматизированных\nпроизводственных решений'
              }
            ]
          },
          rightInfo: {
            yearTitle: 2012,
            mainTitle: 'Год основания'
          }
        },
        {
          id: 1,
          idSlide: 0,
          leftInfo: {
            img: '2014.webp'
          },
          rightInfo: {
            yearTitle: 2014,
            title: 'Начало',
            text: 'Создание бренда AVEA Basis.\n\nОткрытие направления технологическая оснастка.',
          }
        },
        {
          id: 2,
          idSlide: 1,
          leftInfo: {
            img: '2018.webp'
          },
          rightInfo: {
            yearTitle: 2018,
            title: 'Серийное производство',
            text: 'Освоение технологии серийного производства первой в РФ системы нулевого базирования.',
          }
        },
        {
          id: 3,
          idSlide: 2,
          leftInfo: {
            img: '2020.webp'
          },
          rightInfo: {
            yearTitle: 2020,
            title: 'Серийное производство',
            text: 'Расширение номенклатуры технологической оснастки.',
          }
        },
        {
          id: 4,
          idSlide: 3,
          leftInfo: {
            img: '2024.webp'
          },
          rightInfo: {
            yearTitle: 2024,
            title: 'Новые направления',
            text: 'Освоение технологии и серийное производство гидропластовых и термопатронов.',
          }
        },
        {
          id: 5,
          idSlide: 3,
          leftInfo: {
            img: '2024-1.webp'
          },
          rightInfo: {
            yearTitle: 2024,
            title: 'Новые направления',
            text: 'Разработка робота-накопителя для автоматизации работы станков с ЧПУ.',
          }
        },
        {
          id: 6,
          idSlide: 4,
          leftInfo: {
            img: '2025.webp'
          },
          rightInfo: {
            yearTitle: 2025,
            title: 'Новые направления',
            text: 'Разработка роботизированных ячеек с партнерами.',
          }
        },
        {
          id: 7,
          idSlide: 4,
          leftInfo: {
            img: ''
          },
          rightInfo: {
            yearTitle: 2025,
            title: 'Новый имидж',
            text: 'Проведение комплексного ребрендинга.',
          }
        }
      ]
    }
  },
  computed: {
    activeImg() {
      return this.activeItem.leftInfo?.img;
    },
    arrSliderComputed() {
      return this.arrSlider.map(item => {
        if(item.id === 0) {
          return {
            ...item,
            colorTitle: this.isActiveColorTitle(item)
          }
        } else {
          return item
        }
      })
    },
    isFirstSlide() {
      return this.currentSlide === 0
    },
    isLastSlide() {
      return this.currentSlide === (this.totalSlides - 1)
    },
    activeItem() {
      return this.arrSliderComputed.find(item => item.id === this.currentSlide);
    },
    currentSlideForNavigation() {
      return this.activeItem?.idSlide || 0;
    },
    navigationArr() {
      let arr = this.arrSlider.filter((item, index, self) =>
          index === self.findIndex(t => t.rightInfo.yearTitle === item.rightInfo.yearTitle) && item.rightInfo.yearTitle !== 2012
      )
      return arr.map((item, index) => ({
        id: item.idSlide,
        title: item.rightInfo.yearTitle
      }))
    }
  },
  watch: {
    event() {
      this.watcherHorizontalBlock();
    },
  },
  mounted() {
    this.totalSlides = this.arrSlider.length;
    this.checkHeight();
    // this.initHorizontalBlock();
  },
  methods: {
    ...mapActions(['ACTIVE_WHITE_BLOCK']),
    changeId(slide) {
      this.OPTIONS_HORIZONTAL_SCROLL({
        currentSlide: slide,
        isTouch: this.isTouch
      })
    },
    checkHeight() {
      let height = document.querySelector('.right-content-history');
      this.activeHeight = `${height.clientHeight}px`
    },
    isActiveColorTitle(item) {
      let info = item?.leftInfo;
      if(info?.boldText) {
        let title = info.text.match(/\w+@\w+\.\w+|\d+[\.,]?\d*|[^\s/.,-]+|[\/\-,.]/g);
        let titleBold = info.boldText.match(/\w+@\w+\.\w+|\d+[\.,]?\d*|[^\s/.,-]+|[\/\-,.]/g);
        let titleBoldOrange = info.boldOrangeText.match(/\w+@\w+\.\w+|\d+[\.,]?\d*|[^\s/.,-]+|[\/\-,.]/g);
        return {
          title, titleBold, titleBoldOrange
        }
      }
      return false
    },
  }
}
</script>

<style scoped lang="scss">
  .history-screen-container {
    background: var(--color-white);
    height: var(--calc-height);
    transition: all 1s ease;
    &.is-active-first-slide {
      background: var(--color-dark-purple);
      .bg-container {
        & img {
          opacity: .5;
        }
      }
    }
  }

  .horizontal-wrapper {
    overflow: hidden;
    position: relative;
  }

  .horizontal-track {
    position: relative;
    display: flex;
    height: 100%;
    transition: opacity 1s ease;
  }

  .navigation-info-container {
    min-width: var(--calc-width);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 1s ease;

    .navigation-info-content {
      position: relative;
      justify-content: space-between;
      align-items: center;

      .arrow-container {
        pointer-events: none;
        z-index: 11;
        cursor: pointer;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        transition: all .3s ease;
        opacity: 0;
        @media(max-width: 769px) {
          right: 0;
        }

        &.is-first-slide {
          @media(max-width: 769px) {
            right: 0;
          }
        }

        &.is-active {
          pointer-events: auto;
          opacity: 1;
        }

        &:hover {
          opacity: .8;
        }

        &.left-direction {
          right: auto;
          @media(max-width: 769px) {
            left: 0;
          }
          & img {
            transform: rotate(180deg);
          }
        }

        & img {
          width: 100%;
          height: 100%;
        }
      }

      .left-container {
        height: 100%;

        .img-container {
          z-index: 0;
          position: relative;
          top: -20%;
          height: 130%;
          width: 100%;

          .img-content {
            width: 100%;
            height: 100%;
          }

          & img {
            object-fit: contain;
            width: 100%;
            height: 100%;
          }
        }
      }

      .right-container-history {
        position: relative;
        z-index: 11;
        width: 100%;
        transition: all 1s ease;
        height: var(--custom-height);
        .right-content-history {
          height: fit-content;
          width: 100%;
          top: 0;
          left: 0;
          position: absolute;
          @media(max-width: 769px) {
            position: relative;
          }
        }
        .small-title-container {
          position: relative;
          white-space: pre-wrap;
        }
        .medium-title-container {
          position: relative;
        }
        .main-title-container {
          position: relative;
        }
        .big-title-container {
          position: relative;
          display: flex;
          align-items: center;
          flex-direction: row;
          .odometer {
            font-size: inherit !important;
            font-family: inherit !important;
            line-height: inherit !important;
            ::v-deep(.odometer-formatting-mark) {
              display: none;
            }
          }
        }
      }

      .text-info-container {
        z-index: 11;
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .top-container {
          display: flex;
          flex-direction: column;


          .color-title-container {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
          }
        }
        .bottom-container {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }

  .slider-container {
    max-width: var(--main-max-width);
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    position: absolute;
    z-index: 100;
    bottom: 0;
  }
  .bg-container {
    top: 50%;
    transform: translateY(-50%);
    height: 99%;
    right: 0;
    z-index: 10;
    left: auto;
    & img {
      transition: all 1s ease;
      opacity: .06;
      object-fit: contain;
      &.last-item {
        position: relative;
        left: -10%;
        width: 120%;
        opacity: 1 !important;
      }
    }
  }


  @media (max-width: 3840px) {
    .navigation-info-container {
      .navigation-info-content {
        padding-top: 360px;
        padding-bottom: 360px;

        .arrow-container {
          width: 240px;
          height: 240px;
          right: -5%;
          &.is-first-slide {
            right: -5%;
          }
          &.left-direction {
            left: -5%;
          }
        }
        .left-container {
          .img-container {
            max-width: 2113px;
          }
        }

        .right-container-history {
          max-width: 900px;
          .big-title-container {
            font-size: 180px;
          }
          .main-title-container {
            font-size: 56px;
            margin-top: 80px;
          }
          .medium-title-container {
            font-size: 56px;
            margin-top: 80px;
          }
          .small-title-container {
            font-size: 42px;
            margin-top: 45px;
          }
        }

        .text-info-container {
          max-width: 1090px;

          .top-container {
            row-gap: 60px;
            .color-title-container {
              column-gap: 10px;
              row-gap: 10px;
              .active-symbol-word {
                margin-right: -10px;
                margin-left: -10px;
              }
              .active-symbol {
                margin-left: -10px;
              }
            }
          }
          .bottom-container {
            row-gap: 60px;
          }
        }
      }
    }
  }

  @media (max-width: 3420px) {
    .navigation-info-container {
      .navigation-info-content {
        .arrow-container {
          right: 0;
          &.is-first-slide {
            right: 0;
          }
          &.left-direction {
            left: 0;
          }
        }
      }
    }
  }
  @media (max-width: 3024px){

    .navigation-info-container {

      .navigation-info-content {
        padding-top: 160px;
        padding-bottom: 160px;


        .arrow-container {
          width: 80px;
          height: 80px;
          right: -10%;
          &.is-first-slide {
            right: 5%;
          }
          &.left-direction {
            left: -10%;
          }
        }

        .left-container {
          .img-container {
            max-width: 949px;
          }
        }

        .right-container-history {
          max-width: 356px;
          .big-title-container {
            font-size: 54px;
          }
          .main-title-container {
            font-size: 24px;
            margin-top: 16px;
          }
          .medium-title-container {
            font-size: 24px;
            margin-top: 16px;
          }
          .small-title-container {
            font-size: 20px;
            margin-top: 45px;
          }
        }

        .text-info-container {
          max-width: 700px;

          .top-container {
            row-gap: 60px;

            .color-title-container {
              column-gap: 6px;
              row-gap: 3px;
              .active-symbol-word {
                margin-right: -6px;
                margin-left: -6px;
              }
              .active-symbol {
                margin-left: -6px;
              }
            }
          }
          .bottom-container {
            row-gap: 40px;
          }
        }
      }
    }
  }


  @media (max-width: 1920px) {

    .navigation-info-container {

      .navigation-info-content {
        padding-top: 160px;
        padding-bottom: 160px;
        .arrow-container {
          width: 60px;
          height: 60px;
        }

        .left-container {

          .img-container {
            max-width: 860px;
          }
        }

        .right-container-history {
          max-width: 400px;
          .big-title-container {
            font-size: 54px;
          }
          .main-title-container {
            font-size: 24px;
            margin-top: 16px;
          }
          .medium-title-container {
            font-size: 24px;
            margin-top: 20px;
          }
          .small-title-container {
            font-size: 18px;
            margin-top: 20px;
          }
        }

        .text-info-container {
          max-width: 640px;

          .top-container {
            row-gap: 60px;


            .color-title-container {
              column-gap: 6px;
              .active-symbol {
                margin-left: -6px;
              }
            }
          }
          .bottom-container {
            row-gap: 40px;
          }
        }
      }
    }
  }

  @media (max-width: 1800px) {
    .navigation-info-container {
      .navigation-info-content {
        .arrow-container {
          right: -5%;
          &.is-first-slide {
            right: 0;
          }
          &.left-direction {
            left: -5%;
          }
        }
      }
    }
  }


  @media (max-width: 1600px) {

    .navigation-info-container {

      .navigation-info-content {
        padding-top: 100px;
        padding-bottom: 100px;
        .arrow-container {
          width: 60px;
          height: 60px;
          right: -10%;
          &.is-first-slide {
            right: 10%;
          }
          &.left-direction {
            left: -10%;
          }
        }

        .left-container {
          .img-container {
            max-width: 620px;
          }
        }

        .right-container-history {
          max-width: 380px;
          .big-title-container {
            font-size: 46px;
          }
          .main-title-container {
            font-size: 20px;
            margin-top: 16px;
          }
          .medium-title-container {
            font-size: 20px;
            margin-top: 20px;
          }
          .small-title-container {
            font-size: 16px;
            margin-top: 20px;
          }
        }

        .text-info-container {
          max-width: 630px;

          .top-container {
            row-gap: 60px;

            .color-title-container {
              column-gap: 5px;
              .active-symbol-word {
                margin-right: -5px;
                margin-left: -5px;
              }
              .active-symbol {
                margin-left: -5px;
              }
            }
          }
          .bottom-container {
            row-gap: 24px;
          }
        }
      }
    }
  }

  @media (max-width: 1500px) {

    .navigation-info-container {
      .navigation-info-content {
        .arrow-container {
          right: -5%;
          &.is-first-slide {
            right: 12%;
          }
          &.left-direction {
            left: -5%;
          }
        }
      }
    }
  }

  @media (max-height: 800px) {

    .navigation-info-container {
      .navigation-info-content {
        padding-top: 90px;
        padding-bottom: 90px;
        .arrow-container {
          width: 48px;
          height: 48px;
        }

        .left-container {
          .img-container {
            max-width: 520px;
          }
        }

        .right-container-history {
          max-width: 340px;
          .big-title-container {
            font-size: 40px;
          }
          .main-title-container {
            font-size: 18px;
            margin-top: 12px;
          }
          .medium-title-container {
            font-size: 18px;
            margin-top: 20px;
          }
          .small-title-container {
            font-size: 14px;
            margin-top: 20px;
          }
        }

        .text-info-container {
          max-width: 520px;

          .top-container {
            row-gap: 60px;

            .color-title-container {
              column-gap: 5px;
              .active-symbol-word {
                margin-right: -5px;
                margin-left: -5px;
              }
              .active-symbol {
                margin-left: -5px;
              }
            }
          }
          .bottom-container {
            row-gap: 24px;
          }
        }
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {


    .navigation-info-container {

      .navigation-info-content {
        padding-top: 100px;
        padding-bottom: 100px;
        .arrow-container {
          width: 60px;
          height: 60px;
        }

        .left-container {
          .img-container {
            max-width: 620px;
          }
        }

        .right-container-history {
          max-width: 380px;
          .big-title-container {
            font-size: 46px;
          }
          .main-title-container {
            font-size: 20px;
            margin-top: 16px;
          }
          .medium-title-container {
            font-size: 20px;
            margin-top: 20px;
          }
          .small-title-container {
            font-size: 16px;
            margin-top: 20px;
          }
        }

        .text-info-container {
          max-width: 630px;

          .top-container {
            row-gap: 60px;

            .color-title-container {
              column-gap: 5px;
              .active-symbol-word {
                margin-right: -5px;
                margin-left: -5px;
              }
              .active-symbol {
                margin-left: -5px;
              }
            }
          }
          .bottom-container {
            row-gap: 24px;
          }
        }
      }
    }
  }

  @media (max-width: 1133px) {

    .navigation-info-container {
      .navigation-info-content {
        padding-top: 90px;
        padding-bottom: 90px;

        .arrow-container {
          width: 48px;
          height: 48px;
        }
        .left-container {
          .img-container {
            max-width: 520px;
          }
        }

        .right-container-history {
          max-width: 340px;
          .big-title-container {
            font-size: 40px;
          }
          .main-title-container {
            font-size: 18px;
            margin-top: 12px;
          }
          .medium-title-container {
            font-size: 18px;
            margin-top: 20px;
          }
          .small-title-container {
            font-size: 14px;
            margin-top: 20px;
          }
        }

        .text-info-container {
          max-width: 520px;

          .top-container {
            row-gap: 60px;

            .color-title-container {
              column-gap: 5px;
              .active-symbol-word {
                margin-right: -5px;
                margin-left: -5px;
              }
              .active-symbol {
                margin-left: -5px;
              }
            }
          }
          .bottom-container {
            row-gap: 24px;
          }
        }
      }
    }
  }

  @media (max-width: 769px) {

    .history-screen-container {
      &.is-active-first-slide {
        .navigation-info-container {
          .navigation-info-content {
            padding-bottom: 48px;
          }
        }
      }
    }


    .bg-container {
      &.is-not-last {
        max-height: 349px;
        right: -30%;
        top: auto;
        transform: none;
        transition: all 1s ease;
        bottom: 64px;
      }
    }

    .navigation-info-container {
      .navigation-info-content {
        flex-direction: column;
        padding-top: 72px;
        padding-bottom: 116px;
        transition: all 1s ease;


        .arrow-container {
          right: 0;
          &.is-first-slide {
            right: 0;
          }
          &.left-direction {
            left: 0;
          }
        }

        .left-container {
          height: fit-content;
          .img-container {
            top: 0;
            max-height: 320px;
            max-width: 100%;
          }
        }

        .right-container-history {
          max-width: 100%;
          height: 160px;
          &.is-active-first-slide {
            height: 90px;
          }
          .big-title-container {
            font-size: 40px;
          }
          .main-title-container {
            font-size: 18px;
            margin-top: 12px;
          }
          .medium-title-container {
            font-size: 18px;
            margin-top: 14px;
          }
          .small-title-container {
            font-size: 14px;
            margin-top: 14px;
          }
        }

        .text-info-container {
          max-width: 100%;
          margin-bottom: 52px;

          .top-container {
            row-gap: 52px;

            .color-title-container {
              column-gap: 5px;
              .active-symbol-word {
                margin-right: -5px;
                margin-left: -5px;
              }
              .active-symbol {
                margin-left: -5px;
              }
            }
          }
          .bottom-container {
            row-gap: 24px;
          }
        }
      }
    }
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //plus
  }

  @media (min-height: 600px) and (max-height: 630px){

    //8 plus
  }

  @media (max-width: 375px) {
    //se new
  }

  @media (max-width: 375px) and (min-height: 630px) {
    //x
  }


  @media (max-width: 320px) {
    //se old
  }

  @media (min-width: 3841px) {
    .navigation-info-container {
      .navigation-info-content {
        padding-top: 360px;
        padding-bottom: 360px;

        .arrow-container {
          width: 240px;
          height: 240px;
          right: -10%;
          &.is-first-slide {
            right: -5%;
          }
          &.left-direction {
            left: -10%;
          }
        }
        .left-container {
          .img-container {
            max-width: 2113px;
          }
        }

        .right-container-history {
          max-width: 900px;
          .big-title-container {
            font-size: 180px;
          }
          .main-title-container {
            font-size: 56px;
            margin-top: 80px;
          }
          .medium-title-container {
            font-size: 56px;
            margin-top: 80px;
          }
          .small-title-container {
            font-size: 42px;
            margin-top: 45px;
          }
        }

        .text-info-container {
          max-width: 1090px;

          .top-container {
            row-gap: 60px;
            .color-title-container {
              column-gap: 10px;
              row-gap: 10px;
              .active-symbol-word {
                margin-right: -10px;
                margin-left: -10px;
              }
              .active-symbol {
                margin-left: -10px;
              }
            }
          }
          .bottom-container {
            row-gap: 60px;
          }
        }
      }
    }
  }

</style>